import React from "react";
import Perfil from "./componentesmiperfil/informacion-personal";
import FooterMenu from './componenteshome/footer';
import MenuEscritorio from './componenteshome/MenuEscritorio';
import '../css/perfil.css'; 

function Cuenta(){
    return <div><Perfil/><FooterMenu/><MenuEscritorio/></div>
}

export default Cuenta;